import React, { ChangeEvent, useEffect, useState } from "react";
import "./DashboardEntryPanasonicDeliveryInfoWidget.scss";
import moment, { Moment } from "moment-timezone";
import UIService from "../../../services/UIService";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import OwDateInput from "../../shared/OwDateInput/OwDateInput";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";

type Props = {
    updateDetails: (details: any) => void;
    sectionInEditMode: (section: string, inEditMode: boolean) => void;
};

export const DashboardEntryPanasonicDeliveryInfoWidget = (props: Props) => {
    const isMainViewLight = UIService.isMainViewLight();

    const typeOptions: { name: string }[] = [{ name: "One Time" }, { name: "Roll Out" }];

    const [editMode, setEditMode] = useState(false);
    const [deliveryInfoType, setDeliveryInfoType] = useState("");
    const [closingDate, setClosingDate] = useState("");
    const [qtyTiming, setQtyTiming] = useState("");
    const [deliveryDate, setDeliveryDate] = useState("");

    useEffect(() => {
        props.sectionInEditMode("delivery_info", editMode);
        if (!editMode) {
            props.updateDetails({
                deliveryInfoType,
                closingDate,
                qtyTiming,
                deliveryDate,
            });
        }
    }, [editMode]);

    const toggleEditMode = () => {
        setEditMode(!editMode);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        switch (name) {
            case "type":
                setDeliveryInfoType(value);
                break;

            case "closing_date":
                setClosingDate(value);
                break;

            case "qty_timing":
                setQtyTiming(value);
                break;

            case "delivery_date":
                setDeliveryDate(value);
                break;
        }
    };

    const handleDate = (name: string, date: Moment) => {
        switch (name) {
            case "closing_date":
                setClosingDate(date.format("MM/DD/YYYY"));
                break;

            case "delivery_date":
                setDeliveryDate(date.format("MM/DD/YYYY"));
                break;
        }
    };

    return (
        <div className={"DashboardEntryPanasonicDeliveryInfoWidget col-3"}>
            <div className={"d-flex justify-content-between"}>
                <OwLabel title={"delivery_info"} isBold={true} />

                <OwLabel
                    title={editMode ? "save" : "edit"}
                    fn={() => {
                        toggleEditMode();
                    }}
                />
            </div>
            <div className={"card d-flex font-weight-bold card-header flex-grow h-100 " + (!isMainViewLight ? "text-white bg-dark" : "")}>
                <table className={"table " + (isMainViewLight ? "" : "table-dark")}>
                    <tbody>
                        <tr>
                            <th className={"text-end w-8r"}>
                                <OwLabel title={"type"} isBold={true} />
                            </th>
                            <td>
                                {editMode ? (
                                    <OwSelectOption
                                        fn={handleChange}
                                        titleProp={"name"}
                                        valueProp={"name"}
                                        name={"type"}
                                        selectedOption={deliveryInfoType}
                                        hasSelectedOptionProp={false}
                                        options={typeOptions}
                                    />
                                ) : (
                                    deliveryInfoType
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"closing_date"} isBold={true} />
                            </th>
                            <td>
                                {editMode ? (
                                    <OwDateInput
                                        selectedDate={closingDate}
                                        fn={(date: Moment) => {
                                            handleDate("closing_date", date);
                                        }}
                                    />
                                ) : (
                                    closingDate
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"qty_timing"} isBold={true} />
                            </th>
                            <td>{editMode ? <OwFnInput fn={handleChange} name={"qty_timing"} value={qtyTiming} /> : qtyTiming}</td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"delivery_date"} isBold={true} />
                            </th>
                            <td>
                                {editMode ? (
                                    <OwDateInput
                                        selectedDate={deliveryDate}
                                        fn={(date: Moment) => {
                                            handleDate("delivery_date", date);
                                        }}
                                    />
                                ) : (
                                    deliveryDate
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
